import {
  Component, EventEmitter, Injector,
  Input,
  OnInit, Output
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

import { Unidad} from '../../../_models/unidad';
import { EstudioService} from '../estudio.service';
import { HttpClient } from '@angular/common/http';
import { GLMLanguageService} from '../../../_services/glm-language.service';
import { MapaCurricularService} from '../mapa-curricular/_services/mapa-curricular.service';
import { GlmModalService} from '../../../_components/glm-modal/glm-modal.service';
import { CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import { MatDatepickerInputEvent} from '@angular/material/datepicker';
import { MatSnackBar} from '@angular/material/snack-bar';
import { UnidadEtapasService} from '../unidad-etapas/_services/unidad-etapas.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS} from '../../../_models/moment-formats';


@Component({
  selector: 'unidad-form',
  standalone: false,
  templateUrl: './unidad-form.component.html',
  styleUrls: ['unidad-etapas-home.scss'],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})


export class UnidadFormComponent implements OnInit {

  unidadForm: UntypedFormGroup;

  _unidad: Unidad;

  @Input()
  unidad: Unidad;
  @Input()
  materias: any;
  @Input()
  profesores: any;
  @Input()
  _periodos: any = [];

  @Output()
  isDirty = new EventEmitter();
  @Output()
  formLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  materiasPeriodoOpts: any = [];
  profesoresOpts: any = [];
  alumnosIEPOpts = [];
  periodos: any = [];

  guardando = false;
  unidadReady = false;
  isModal = false;

  fechaIniciaMinMax: any;
  fechaFinMinMax: any;
  fechaPubMinMax: any;

  constructor(private fb: UntypedFormBuilder,
              private injector: Injector,
              private http: HttpClient,
              private snackBar: MatSnackBar,
              private estudioService: EstudioService,
              private unidadEtapasService: UnidadEtapasService,
              private mapaCurricularService: MapaCurricularService,
              private modalService: GlmModalService,
              private languageService: GLMLanguageService,
              private customAlertService: CustomAlertService) {
  }

  ngOnInit() {
    this._unidad = this.injector.get('unidad', null);
    this.materiasPeriodoOpts = this.injector.get('materiasPeriodo', []);
    this.profesoresOpts = this.injector.get('profesores', []);
    this.periodos = this.injector.get('periodos', []);
    // this.alumnosIEPOpts = this.injector.get('alumnosIEP', {});

    if (this._unidad == null) {
      this.materiasPeriodoOpts = this.materias;
      this.profesoresOpts = this.profesores;
      this.periodos = this._periodos;

      this.estudioService.getUnidad(this.unidad.id).subscribe(res => {
        this._unidad = this.estudioService.extractData(res);
        this.fechaIniciaMinMax = {
          min: this._unidad.periodo.fechaInicia.substring(0, 10),
          max: this._unidad.periodo.fechaFin.substring(0, 10)
        };
        this.fechaFinMinMax = {
          min: this._unidad.periodo.fechaInicia.substring(0, 10),
          max: this._unidad.periodo.fechaFin.substring(0, 10)
        };
        this.fechaPubMinMax = {
          min: this._unidad.periodo.fechaInicia.substring(0, 10),
          max: this._unidad.periodo.fechaFin.substring(0, 10)
        };
        this.buildForm();
      }, err => {

      });
    } else {
      this.isModal = true;
      this.fechaIniciaMinMax = {
        min: this._unidad.periodo.fechaInicia.substring(0, 10),
        max: this._unidad.periodo.fechaFin.substring(0, 10)
      };
      this.fechaFinMinMax = {
        min: this._unidad.periodo.fechaInicia.substring(0, 10),
        max: this._unidad.periodo.fechaFin.substring(0, 10)
      };
      this.fechaPubMinMax = {
        min: this._unidad.periodo.fechaInicia.substring(0, 10),
        max: this._unidad.periodo.fechaFin.substring(0, 10)
      };

      this.buildForm();
    }
  }

  buildForm() {
    const currNombre = this._unidad.nombre,
      currResumen = this._unidad.resumen,
      currFechaInicia = this._unidad.fechaInicia,
      currFechaPublicar = this._unidad.fechaPublicar,
      currFechaFin = this._unidad.fechaFin,
      currMateriasPeriodo = this._unidad.materias && this._unidad.materias.length > 0 ?
        this._unidad.materias.map(materia => {
          return materia.id;
        }) : [],
      currEditores = this._unidad.editores && this._unidad.editores.length > 0 ?
        this._unidad.editores.map(editor => {
          return editor.id;
        }) : [],
      currAlumnosIEP = this._unidad.alumnosIEP && this._unidad.alumnosIEP.length > 0 ?
        this._unidad.alumnosIEP.map(alumno => {
          return alumno.id;
        }) : [],
      currClasesEsperadas = this._unidad.clasesEsperadas || 0,
      currEstadoActiva = this._unidad.isActive;

    this.unidadForm = this.fb.group({
      nombre: [currNombre, Validators.required],
      resumen: [currResumen],
      fechaInicia: [currFechaInicia, Validators.required],
      fechaFin: [currFechaFin, Validators.required],
      fechaPublicar: [currFechaPublicar],
      clasesEsperadas: [currClasesEsperadas],
      materiasPeriodo: [currMateriasPeriodo, Validators.required],
      editores: [currEditores],
      alumnosIEP: [currAlumnosIEP],
      isActive: [currEstadoActiva]
    });
    if (currMateriasPeriodo.length > 0) {
      this.seleccionMCP(false);
    }
    this.unidadReady = true;

    this.formLoaded.emit(true);
    this.onChanges();
  }

  onChanges() {
    this.unidadForm.valueChanges.subscribe(val => {
      if (!this.unidadForm.pristine) {
        this.isDirty.emit(true);
      }
    });
  }

  dateChange(type: string, event: MatDatepickerInputEvent<any>) {
    const fecha = event.value;
    if (type === 'fechaInicio') {
      this.fechaFinMinMax.min = fecha.format('YYYY-MM-DD');
      this.fechaPubMinMax.min = fecha.format('YYYY-MM-DD');
    }
    if (type === 'fechaFin') {
      this.fechaPubMinMax.max = fecha.format('YYYY-MM-DD');
    }
  }

  seleccionMCP(isOpen) {
    if (!isOpen) {
      const idsMCP = this.unidadForm.get('materiasPeriodo').value;
      if (idsMCP.length > 0) {
        this.estudioService.getAlumnosIEP(idsMCP.toString()).subscribe(res => {
          this.alumnosIEPOpts = res as any[];
          if (!this.unidadForm.get('alumnosIEP')) {
            this.unidadForm.addControl('alumnosIEP', new UntypedFormControl());
          }
          if (this.alumnosIEPOpts.length == 0) {
            this.unidadForm.patchValue({alumnosIEP: null});
          }
        }, err => {
          console.error('Error en la petición.');
        });
      } else {
        this.alumnosIEPOpts = [];
        this.unidadForm.patchValue({alumnosIEP: []});
      }
    }
  }

  guardar() {
    const formVals = this.unidadForm.value;

    this.guardando = true;
    this._unidad.nombre = formVals.nombre;
    this._unidad.resumen = formVals.resumen && formVals.resumen.length > 0 ? formVals.resumen : '';
    this._unidad.fechaInicia = formVals.fechaInicia ? formVals.fechaInicia : '';
    this._unidad.fechaFin = formVals.fechaFin ? formVals.fechaFin : '';
    this._unidad.fechaPublicar = formVals.fechaPublicar ? formVals.fechaPublicar : '';
    this._unidad.materias = formVals.materiasPeriodo.length > 0 ?
      formVals.materiasPeriodo.map(materiaPeriodo => {
        return {id: materiaPeriodo};
      }) : [];
    this._unidad.editores = formVals.editores.length > 0 ?
      formVals.editores.map(editor => {
        return {id: editor};
      }) : [];
    this._unidad.alumnosIEP = formVals.alumnosIEP && formVals.alumnosIEP.length > 0 ?
      formVals.alumnosIEP.map(alumno => {
        if (this.alumnosIEPOpts.filter(alu => alu.id === alumno).length === 1) {
          return {id: alumno};
        }
      }) : [];
    this._unidad.clasesEsperadas = formVals.clasesEsperadas;
    this._unidad.isActive = formVals.isActive;
    if (this._unidad.alumnosIEP[0] == null) {
      this._unidad.alumnosIEP = [];
    }

    if (this._unidad.id > 0) {
      this.estudioService.actualizarUnidad(this._unidad).subscribe(resp => {
        this.estudioService.actualizarElemento('unidad', resp);
        if (this.isModal) {
          this.modalService.cerrarModal();
        } else {
          this.guardando = false;
          this.snackBar.open(
            `La unidad se ha guardado correctamente.`,
            null,
            {duration: 2250});
          this.unidadEtapasService.setMaterias(this.estudioService.extractData(resp).materias);
          this.unidadForm.markAsPristine();
          this.isDirty.emit(false);
        }
      }, err => {
        this.guardando = false;
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la unidad.  <br> Mensaje de error: ${err.error}<br> Código de error: ${err.statusText}`
        });
      });
    } else {
      this.estudioService.crearUnidad(this._unidad).subscribe(resp => {
        const nuevaUnidad = new Unidad(resp);
        this.guardando = false;
        this.estudioService.actualizarElemento('nueva-unidad', nuevaUnidad);
        const modelo = {
          idOrigen: nuevaUnidad.id,
          estado: false
        };
        this.estudioService.setUnidadFavorita(modelo);
        }, err => {
          this.guardando = false;
          this.customAlertService.setCustomMessage({
            tipo: 'error',
            texto: `No ha sido posible crear la unidad. ${err.error} <br> Código de error: ${err.statusText}`
          });
      });
    }
  }

  cancelar() {
    this.modalService.cerrarModal();
  }
}
